import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import * as M from "@discovery/prelude/lib/data/maybe";
import { MastHeadTags } from "../../atoms/mast-head-tags";
import { PlayWithLabel, PlayWithLabelVariants, } from "../../atoms/play-with-label/";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import * as Styles from "./styles.css";
export const CarouselContentCard = ({ name, ctaLabelM, descriptionM, customAttr = M.empty(), }) => {
    const tagscolorList = Object.values(config.masthead.item).map((key) => key);
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { classNameM: M.of(Styles.name), variant: HeaderVariants.headingThree, tag: Tags.h3 },
            React.createElement(React.Fragment, null, name)),
        React.createElement(RenderMaybe, null, M.map((description) => (React.createElement(Typography, { classNameM: M.of(Styles.description), variant: HeaderVariants.headingFour, tag: Tags.h4 },
            React.createElement(React.Fragment, null, description))), descriptionM)),
        React.createElement(RenderMaybe, null, M.map((customAttr) => {
            return (React.createElement("div", { className: Styles.tagsWrapper },
                React.createElement("div", { className: Styles.tagsContainer }, Object.values(customAttr).map((value, index) => {
                    return (React.createElement(MastHeadTags, { mastHeadTagColor: tagscolorList && tagscolorList[index], customAttrTag: value, key: index }));
                }))));
        }, customAttr)),
        !M.equals(ctaLabelM, M.of(undefined)) && (React.createElement(PlayWithLabel, { variant: PlayWithLabelVariants.smallLabel, labelM: ctaLabelM }))));
};

